import styled from '@emotion/styled';
import PostCard from '@ep/modules/PostFeatureModule/Post/PostCard';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface PostProps {
  post: Gcms_Post[];
}

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  scroll-snap-align: start;
  flex-shrink: 0;

  :not(:first-of-type) {
    margin-left: 5rem;
  }

  ${theme.mediaQueries.mobileAndTablet} {
    flex-direction: column;
  }
`;

function Post({ post }: PostProps) {
  return (
    <Content>
      {post.map(post => (
        <PostCard key={`Feature_Post_tab__${post.id}`} post={post} />
      ))}
    </Content>
  );
}

export default Post;
